export enum SortingDirection {
  ASC = 'asc',
  DESC = 'desc',
}
